module.exports = __webpack_public_path__ + "img/Avatar-62.783028fa.svg";